import { useEffect, useState } from 'react';
import { useAgendaContext } from '../ContextAgenda';
import { HorariosAtendenteService } from '../../Service';
import { useAppContext } from '../../../../contexts/AppContext';
import { EyeOff } from 'lucide-react';

const service = new HorariosAtendenteService();

const moneyFormatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
});

const PERIODS = [
    { key: 'day', label: 'Projeção do dia' },
    { key: 'week', label: 'Projeção da semana' },
    { key: 'month', label: 'Projeção do mês' },
];

export const Projecao = () => {
    const { attendantId, date, schedules } = useAgendaContext();
    const { hiddenValue } = useAppContext();
    const [result, setResult] = useState<{ key: string; data: any } | null>(null);
    // `date` e um novo objeto a cada render do provider; o valor numerico identifica o dia.
    const dateValue = date.valueOf();
    const requestKey = `${attendantId}:${dateValue}`;
    const current = result?.key === requestKey ? result : null;

    // `schedules` muda quando a agenda recarrega, o que pode alterar os totais.
    useEffect(() => {
        if (!attendantId) {
            return;
        }

        let active = true;

        service.getProjecao(new Date(dateValue), attendantId)
            .then(({ data }) => {
                if (active) setResult({ key: requestKey, data });
            })
            .catch((error) => {
                console.error('Erro ao buscar projeção:', error);
                // Falha ao atualizar mantem o ultimo valor; sem valor, nao mostra R$ 0,00.
                if (active) setResult((previous) => (previous?.key === requestKey ? previous : { key: requestKey, data: null }));
            });

        return () => {
            active = false;
        };
    }, [attendantId, dateValue, requestKey, schedules]);

    const renderValue = (key: string) => {
        if (hiddenValue) {
            return <EyeOff className="text-base-content/50" role="img" aria-label="Valor oculto" />;
        }
        if (!current) {
            return <span className="sf-skeleton inline-block h-3.5 w-16 max-w-full" role="status" aria-label="Carregando" />;
        }
        if (!current.data) {
            return <span className="text-base-content/50" role="img" aria-label="Não foi possível carregar">—</span>;
        }
        return moneyFormatter.format(current.data[key] || 0);
    };

    return (
        <dl className="sf-projection">
            {PERIODS.map(({ key, label }) => (
                <div key={key}>
                    <dt>{label}</dt>
                    <dd>{renderValue(key)}</dd>
                </div>
            ))}
        </dl>
    );
};
